import { FormControl, TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

const ControllerField = ({ control, label, name, required = true, type = 'text', allowPaste = true }) => {

  return (
    <Controller
      rules={{required}}
      control={control}
      name={name}
      render={({ field, fieldState: {error} }) => (
        <FormControl fullWidth variant='outlined' >
          <TextField
            {...field}
            fullWidth
            name={name}
            type={type}
            label={label}
            variant="outlined"
            error={error}
            onPaste={(target) => {
              if (!allowPaste) {
                target.preventDefault()
              }
            }}
          />
        </FormControl>
      )}
    />
  )
}

export default ControllerField
